// See https://sync.hudl.com/display/COMM/Highlights+API+-+V3
export const USER = 1;
export const TEAM = 2;
